__turbopack_context__.v({
  "button": "snipe-module__g5Zxfa__button",
  "container": "snipe-module__g5Zxfa__container",
  "content": "snipe-module__g5Zxfa__content",
  "description": "snipe-module__g5Zxfa__description",
  "snipe": "snipe-module__g5Zxfa__snipe",
  "title": "snipe-module__g5Zxfa__title",
});
